import React, { useState, useRef, useEffect } from 'react';
import './StatusButton.css';

const ANIME_STATUS_OPTIONS = [
    { value: 'CURRENT', label: 'Watching', emoji: '▶️', color: '#4CAF50' },
    { value: 'COMPLETED', label: 'Completed', emoji: '✅', color: '#2196F3' },
    { value: 'PLANNING', label: 'Planning', emoji: '📅', color: '#FF9800' },
    { value: 'REPEATING', label: 'Rewatching', emoji: '🔄', color: '#9C27B0' },
    { value: 'PAUSED', label: 'On Hold', emoji: '⏸️', color: '#9E9E9E' },
    { value: 'DROPPED', label: 'Dropped', emoji: '❌', color: '#F44336' }
];

const MANGA_STATUS_OPTIONS = [
    { value: 'CURRENT', label: 'Reading', emoji: '📖', color: '#4CAF50' },
    { value: 'COMPLETED', label: 'Completed', emoji: '✅', color: '#2196F3' },
    { value: 'PLANNING', label: 'Planning', emoji: '📅', color: '#FF9800' },
    { value: 'REPEATING', label: 'Rereading', emoji: '🔄', color: '#9C27B0' },
    { value: 'PAUSED', label: 'On Hold', emoji: '⏸️', color: '#9E9E9E' },
    { value: 'DROPPED', label: 'Dropped', emoji: '❌', color: '#F44336' }
];


const StatusButton = ({ currentStatus, onChange, disabled, isLoading, type = 'anime' }) => {
    const [isOpen, setIsOpen] = useState(false);
    const dropdownRef = useRef(null);

    const STATUS_OPTIONS = type === 'manga' ? MANGA_STATUS_OPTIONS : ANIME_STATUS_OPTIONS;
    const currentOption = STATUS_OPTIONS.find(opt => opt.value === currentStatus);

    // Close dropdown when clicking outside
    useEffect(() => {
        const handleClickOutside = (event) => {
            if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
                setIsOpen(false);
            }
        };

        if (isOpen) {
            document.addEventListener('mousedown', handleClickOutside);
        }

        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, [isOpen]);

    const handleButtonClick = (e) => {
        e.stopPropagation();
        if (!disabled && !isLoading) {
            setIsOpen(!isOpen);
        }
    };

    const handleOptionClick = (e, option) => {
        e.stopPropagation();
        if (option.value !== currentStatus) {
            onChange(option.value);
        }
        setIsOpen(false);
    };

    return (
        <div className="status-button-wrapper" ref={dropdownRef}>
            <button
                className={`status-button ${isLoading ? 'loading' : ''}`}
                onClick={handleButtonClick}
                disabled={disabled || isLoading}
                style={{ borderColor: currentOption?.color }}
                title={type === 'manga' ? 'Change manga status' : 'Change anime status'}
            >
                <span className="status-button-emoji">{currentOption?.emoji}</span>
                <span className="status-button-label">{currentOption?.label}</span>
                <span className="status-button-arrow">{isOpen ? '▲' : '▼'}</span>
            </button>

            {isOpen && (
                <div className="status-dropdown">
                    {STATUS_OPTIONS.map(option => (
                        <button
                            key={option.value}
                            className={`status-option ${option.value === currentStatus ? 'active' : ''}`}
                            onClick={(e) => handleOptionClick(e, option)}
                            style={{
                                borderLeftColor: option.color,
                                backgroundColor: option.value === currentStatus ? 'rgba(6, 182, 212, 0.1)' : 'transparent'
                            }}
                        >
                            <span className="status-option-emoji">{option.emoji}</span>
                            <span className="status-option-label">{option.label}</span>
                            {option.value === currentStatus && <span className="status-option-check">✓</span>}
                        </button>
                    ))}
                </div>
            )}
        </div>
    );
};

export default StatusButton;
